import React from 'react';
import { CheckCircle, X } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import PlayedTracksHistory from '../PlayedTracksHistory';

const HistoryPanel = ({
  playedTracks,
  totalDuration,
  formatDuration,
  onClearHistory
}) => {
  const handleClearHistory = () => {
    if (window.confirm('Vider l\'historique des titres joués ?')) {
      onClearHistory();
      toast.success('Historique vidé');
    }
  };

  return (
    <div className="flex-1 bg-dark-card/80 backdrop-blur-xl border border-sunset-orange/30 rounded-lg p-3 flex flex-col min-h-0">
      <div className="flex items-center justify-between mb-2 flex-shrink-0">
        <div className="flex items-center gap-2">
          <CheckCircle className="w-4 h-4 text-green-400" />
          <h2 className="text-sm font-semibold text-text-primary">Titres joués</h2>
        </div>
        <div className="flex items-center gap-2">
          <span className="px-1.5 py-0.5 rounded-full text-xs bg-green-500/20 text-green-300">
            {playedTracks.length}
          </span>
          <span className="text-xs text-sunset-orange/60">•</span>
          <span className="px-1.5 py-0.5 rounded-full text-xs bg-green-500/10 text-green-300 font-mono">
            {formatDuration(totalDuration)}
          </span>
          {playedTracks.length > 0 && (
            <Button
              onClick={handleClearHistory}
              size="sm"
              variant="ghost"
              className="h-6 w-6 p-0 text-red-400 hover:text-red-300 hover:bg-red-500/10"
              title="Vider l'historique"
            >
              <X className="w-3 h-3" />
            </Button>
          )}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto min-h-0" style={{scrollbarWidth: 'thin', scrollbarColor: 'rgb(147 51 234) rgb(30 41 59)'}}>
        <PlayedTracksHistory tracks={playedTracks} />
      </div>
    </div>
  );
};

export default HistoryPanel;
